import { useContext } from 'react';
import { Typography, Box, Divider, Stack } from '@mui/material';

import { LinearProgress, Card, CardContent, InfoField } from '@occc/ui-design-system';
import { SiteManagementLocationFragment } from '@occc/graphql';

import { LocationScanDataAltriaDetails } from './LocationScanDataAltriaDetails';
import { LocationScanDataMSADetails } from './LocationScanDataMSADetails';

import { LocationFormRenderProps } from '../types';
import { LocationContext } from '../LocationProvider';

type LocationScanDataContainerProps = Pick<LocationFormRenderProps, 'handleSubmit'> & {
  data: SiteManagementLocationFragment | null;
};

export const LocationScanDataContainer = ({ data }: LocationScanDataContainerProps) => {
  const { loading } = useContext(LocationContext);
  const altriaMan = data?.altriaMan || null;
  const altriaRcn = data?.altriaRcn || null;
  const altriaPPlusApiEnabled = data?.altriaPPlusApiEnabled ?? null;
  const rjrAccountNumber = data?.rjrAccountNumber || null;
  const rjrRbdsCode = data?.rjrRbdsCode || null;
  const rjrAutoOffersEnabled = data?.rjrAutoOffersEnabled ?? null;

  return (
    <Card>
      {loading && <LinearProgress />}
      <CardContent component={Stack} divider={<Divider />} spacing={3}>
        <Box>
          <Typography variant='h6' mb={3}>
            Scan Data
          </Typography>
          <InfoField mb={3} label='Scan Data Status' />
        </Box>
        <Box>
          <Typography variant='h6' mb={3}>
            Altria
          </Typography>
          <LocationScanDataAltriaDetails
            altriaMan={altriaMan}
            altriaRcn={altriaRcn}
            altriaPPlusApiEnabled={altriaPPlusApiEnabled}
          />
        </Box>
        <Box>
          <Typography variant='h6' mb={3}>
            RJR
          </Typography>
          <LocationScanDataMSADetails
            rjrAccountNumber={rjrAccountNumber}
            rjrRbdsCode={rjrRbdsCode}
            rjrAutoOffersEnabled={rjrAutoOffersEnabled}
          />
        </Box>
      </CardContent>
    </Card>
  );
};
